import React from "react";
import { Link, useParams } from "react-router-dom";
import { Alert, IconButton, Snackbar, Typography } from "@mui/material";
import { colors } from "../../theme/colors";
import { CardWrapper, MainContainer } from "./style";
import { CustomTextField } from "../../components/common-components/CustomTextField";
import { CustomButton } from "../../components/common-components/CustomButton";
import { useResetPasswordForm } from "./useResetPassword";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import logo from "../../assets/Images/element-wordmark-light.svg";
const ResetPassword = ({}) => {
  const { token } = useParams();
  const {
    alert,
    isLoading,
    formik,
    handleClose,
    showNewPassword,
    showConfirmNewPassword,
    toggleNewPasswordVisibility,
    toggleConfirmNewPasswordVisibility,
  } = useResetPasswordForm(token);

  return (
    <MainContainer>
      <Snackbar
        open={alert.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleClose}
          severity={alert.severity}
          sx={{ width: "100%" }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
      <CardWrapper>
        <img className="logo" src={logo} alt="Berlin" />
        <Typography variant="h1" className="heading" sx={{ mb: 2 }}>
          Reset Your Password
        </Typography>
        <form onSubmit={formik.handleSubmit} style={{ width: "100%" }}>
          <CustomTextField
            id="password"
            name="password"
            type= {showNewPassword ? "text" : "password"}
            variant="outlined"
            fullWidth
            label="New Password"
            margin="normal"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            InputProps={{
              endAdornment: (
                <IconButton onClick={toggleNewPasswordVisibility}>
                  {showNewPassword ? (
                    <VisibilityOffIcon/>
                  ) : (
                    <VisibilityIcon/>
                  )}
                </IconButton>
              ),
            }}
          />
          <CustomTextField
            id="passwordConfirm"
            name="passwordConfirm"
            type={showConfirmNewPassword ? "text" : "password"}
            variant="outlined"
            fullWidth
            label="Confirm New Password"
            margin="normal"
            value={formik.values.passwordConfirm}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.passwordConfirm &&
              Boolean(formik.errors.passwordConfirm)
            }
            helperText={
              formik.touched.passwordConfirm && formik.errors.passwordConfirm
            }
            InputProps={{
              endAdornment: (
                <IconButton onClick={toggleConfirmNewPasswordVisibility}>
                  {showConfirmNewPassword ? (
                    <VisibilityOffIcon/>
                  ) : (
                    <VisibilityIcon />
                  )}
                </IconButton>
              ),
            }}
          />
          <CustomButton
            variant="contained"
            fullWidth
            sx={{
              mt: 3,
              mb: 2,
              backgroundColor: colors.primary,
              color: "#fff",
              height: "46px",
              borderRadius: "10px",
              textTransform: "none",
              fontWeight: 600,
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: colors.primaryHover,
                boxShadow: "0 8px 20px rgba(127, 29, 29, 0.22)",
                transform: "translateY(-1px)",
              },
              "&:active": {
                transform: "translateY(0px)",
              },
              "&.Mui-disabled": {
                backgroundColor: colors.buttonDisabled.background,
                color: colors.buttonDisabled.color,
              },
            }}
            type="submit"
            disabled={formik.isSubmitting || isLoading}
          >
            {formik.isSubmitting || isLoading
              ? "Resetting..."
              : "Reset Password"}
          </CustomButton>
          <Typography className="back-button" sx={{ mt: 1 }}>
            <Link
              to="/"
              style={{ textDecoration: "none", color: "inherit", transition: "color 0.2s" }}
            >
              Go to log in page
            </Link>
          </Typography>
        </form>
      </CardWrapper>
    </MainContainer>
  );
};

export default ResetPassword;
